export default "__VITE_ASSET__6f04bedb__"